export default "__VITE_ASSET__Dgneg5OI__"